var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AppDropdownMenu',{attrs:{"items":_setup.menuItems,"offset-y":"","nudge-top":_vm.nudgeTop},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,slot){return {key:slot,fn:function(scope){return [_vm._t(slot,null,null,scope)]}}})],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }